export const SITE = {
  name: "ASHIR GROUP",
  whatsappNumber: "351930715823", // international format, no symbols
  whatsappDisplay: "+351 93 071 5823",
  email: "contato@ashirgroup.com.br",
  address: {
    street: "Rua Dr. Guilherme Bannitz, 126 — Conj. 81",
    building: "Edifício George Town — Itaim Bibi",
    city: "São Paulo — SP",
    cep: "CEP: 04532-060",
  },
  social: {
    instagram: "https://instagram.com/",
    linkedin: "https://www.linkedin.com/feed/",
  },
  cnpj: "12.280.786/0001-27",
};

export const waLink = (msg = "Olá, gostaria de saber mais sobre as cartas de consórcio contempladas da ASHIR GROUP.") =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
